import { render, staticRenderFns } from "./Linker.vue?vue&type=template&id=bbe482fe&scoped=true"
import script from "./Linker.vue?vue&type=script&lang=js"
export * from "./Linker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe482fe",
  null
  
)

export default component.exports